import { Messages } from '~src/codegen/Localize';
import { IDataSourceBase } from '~src/datasource/models/IDataSourceInfo';
import { DataSources } from '~src/datasource/resources/Datasources';
import { IError } from '~src/httpClient/serverApi/types/IError';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { CommonErrorCode, DatasourceErrorCode } from '~src/ts/helpers/ErrorCodes';
import { L10n } from '~src/ts/L10n/L10n';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

export namespace ChangeDatasourceDescriptionAction {

  export function execute(datasource: IDataSourceBase, newDescription: string): Promise<IResult> {

    return DataSources.setDescription(datasource.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: errorMessageFor(result.errors[0], datasource) });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });
  }

  function errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      case DatasourceErrorCode.DatasourceDescriptionGreaterThanMaxLength:
        return Messages.errorDatasourceDescriptionTooLong({ MAX_LENGTH: getSessionManagementServiceInstance().maxDescriptionLength().toString() });
      case CommonErrorCode.DatasourceNotFound:
        return Messages.errorDatasourceNotFound({ DATASOURCE_NAME: L10n.elideIfLong(datasource.name) });
      default:
        return Messages.errorUnknown();
    }
  }
}

export type ChangeDatasourceDescriptionAction = typeof ChangeDatasourceDescriptionAction;
